import { styled } from '@mui/material';

import { UnfoldLessIcon, UnfoldMoreIcon } from '@app-velocity/icons';
import { AiResponseSummary } from '@app-velocity/ui';

import { useSingleAiResponseContext } from '../hooks/useSingleAiResponseContext';

const StyledCollapseButton = styled('button')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  fontSize: 12,
  color: '#6B7181',
  fontWeight: 400,
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  border: 'none',
  background: 'transparent',
  padding: 0,
  svg: {
    fill: 'var(--text-text-tertiary-color)',
  },
}));

export const Action = () => {
  const { response, collapsed, toggleCollapse } = useSingleAiResponseContext();

  if (!response) return null;

  return (
    <AiResponseSummary
      response={response}
      onClick={toggleCollapse}
      variant="compact"
      endAdornment={
        <StyledCollapseButton>
          {collapsed ? <UnfoldMoreIcon /> : <UnfoldLessIcon />}
        </StyledCollapseButton>
      }
    />
  );
};
